module.exports = __webpack_public_path__ + "static/media/organization.7f459ea5.svg";